import React, { PureComponent, Component } from "react";
import { requestUnporcessedLegalDataForModeration, postProcessedDataToServer, 
    requestUnprocessedAdditionalLegalDataForModeration, postProcessedAdditionalLegalDataToServer, downloadLegalBulkDeleteTemplate, uploadBulkDeleteExcel } from './action';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Modal from "../../../../components/UI/Modal/Modal"; 
import Preloader from '../../../../components/UI/Preloader/index';
import { Preloading } from '../../../../components/UI/Preloader/action';
import { getCrawlerStatus } from '../../CommonComponent/action'; 
import {  Table, ModalHeader, ModalBody, ModalFooter, Row, Col, Button } from 'reactstrap';
import ViewLegalCases from "./TableView";
import { toast, ToastContainer} from 'react-toastify';
import _ from "lodash";
import { GridLoader } from 'react-spinners';
const CLOSE = "CLOSE";
const SUBMIT = "SUBMIT";
const CANCEL = "CANCEL";
const PROCEED = "PROCEED";
const SUBMITDATE = "SUBMITDATE";
const BULK_DELETE = "BULK_DELETE";
class LegalModeration extends Component {

    state = { legalCases: {}, confirmModal: false, modalMessage: "", type: "", modalheader: "", resizeZIndex : false, dateOfInc : "",bulkDeleteFile: null, selectedFileName: "" }

    
    handleOnChange = (e, index) => {
            let legalCases = this.state.legalCases;
            let obj = this.state.legalCases[index];
            let invalidCaseCount = this.state.invalidCaseCount;
            if(e.target.checked){
                obj = {...obj, caseInvalid : true};
                invalidCaseCount = invalidCaseCount + 1;
            }else{
                obj = {...obj, caseInvalid : false}
                invalidCaseCount =invalidCaseCount - 1 ;
            }
            legalCases[index] = obj;
            this.setState({ legalCases : legalCases, invalidCaseCount : invalidCaseCount })
    }

    handleFileUploadChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            this.setState({
                bulkDeleteFile: file,
                selectedFileName: file.name
            });
        }
    };
    handleBulkDeleteConfirm = () => {
        let modalheader = "Bulk Deletion via Excel";
        let modalMessage = `Are you sure you wish to upload '${this.state.selectedFileName}' and process the bulk deletion?`;
        this.setState({
            confirmModal: !this.state.confirmModal,
            type: BULK_DELETE,
            modalMessage: modalMessage,
            modalheader: modalheader
        });
    }

    downloadBulkDeleteTemplate = () => {
        const { moderationType, legalUnprocessedData, additionalLegalUnprocessedData } = this.props;
        debugger;
        const id = moderationType === "LEGAL"
            ? legalUnprocessedData?.counterpartyId
            : additionalLegalUnprocessedData?.counterpartyId;

        if (id) {
            this.props.downloadLegalBulkDeleteTemplate(id);

        } else {
            toast.error("Counterparty ID not found.");
        }
    }

    executeBulkDeleteUpload = () => {
        const { bulkDeleteFile } = this.state;
        const { moderationType, legalUnprocessedData, additionalLegalUnprocessedData, corporateId } = this.props;

        const id = moderationType === "LEGAL"
            ? legalUnprocessedData.counterpartyId
            : additionalLegalUnprocessedData.counterpartyId;

        const formData = new FormData();
        formData.append("file", bulkDeleteFile);
        formData.set("corporateId", this.props.corporateId);
        formData.append("counterpartyId", id);
        this.setState({ isExecutingTask: true, resizeZIndex: true });
        this.props.Preloading(true);

        this.props.uploadBulkDeleteExcel(formData);




    }

    handleConfirmModalButton = (type, moderationType) => {
        if (type === PROCEED) {
            if (this.state.type === BULK_DELETE) {
            this.executeBulkDeleteUpload();
        } else if (moderationType == "LEGAL"){
                if (this.state.type === CLOSE) {
                    this.props.moderateLegal();
                } else if (this.state.type == SUBMIT &&  this.state.invalidCaseCount > 0){
                    this.props.postProcessedDataToServer( { data : {...this.props.legalUnprocessedData, legalCases : Object.values(this.state.legalCases), crawler: "LEGAL"}, corporateId : this.props.corporateId });
                    this.props.Preloading(true);
                    this.setState({resizeZIndex : true})
                } 
                else if (this.state.type == SUBMITDATE && this.state.dateOfInc != null) {
                    this.props.postProcessedDataToServer({data: {dateOfIncorporation : moment(this.state.dateOfInc).format("DD-MM-YYYY"), 
                        filterByDate: true, counterpartyId: this.props.legalUnprocessedData.counterpartyId, crawler: "LEGAL"}, corporateId: this.props.corporateId});
                    this.props.Preloading(true);
                    this.setState({resizeZIndex : true});
                }
                else{
                    this.props.moderateLegal();
                }
            } else {
                if (this.state.type === CLOSE) {
                    this.props.moderateAdditionalLegal();
                } else if (this.state.type == SUBMIT &&  this.state.invalidCaseCount > 0){
                    this.props.postProcessedAdditionalLegalDataToServer( { data : {...this.props.additionalLegalUnprocessedData, legalCases : Object.values(this.state.legalCases), crawler: "ADDITIONAL_LEGAL"}, corporateId : this.props.corporateId });
                    this.props.Preloading(true);
                    this.setState({resizeZIndex : true})
                }
                else{
                    this.props.moderateAdditionalLegal();
                }
            }
            
        }
        this.setState({ confirmModal : !this.state.confirmModal });
    }

    handleButton = ( type) =>{
        let modalMessage = "";
        let modalheader = "";
        if(type === CLOSE){
            modalMessage = " Are you sure you wish to close ?";
            modalheader = " Close Moderation Screen ?";
        }else{
            modalheader = "Removing Legal Cases";
            modalMessage = ` Are you sure you wish to delete ${this.state.invalidCaseCount} legal cases ?`;
        }
        this.setState({ confirmModal: !this.state.confirmModal, type: type, modalMessage: modalMessage,  modalheader: modalheader });
    }

    handleButtonDateOfInc = ( type ) => {
        let modalMessage = ` Are you sure you wish to delete ALL LEGAL CASES BEFORE ${moment(this.state.dateOfInc).format("DD-MM-YYYY")} ?`;
        let modalheader = "Removing Legal Cases";
        this.setState({ confirmModal: !this.state.confirmModal, type: type, modalMessage: modalMessage,  modalheader: modalheader });
    }

    checkStringIsEmptyOrNull = (str) => {
        if (str === undefined || str === "undefined " || str === null || str === "null" || str.trim().length == 0) {
            return true;
        } else
            return false;
    }

    getPetitioner = ( caseObject ) => {
		let petitioner = "";
        petitioner =  this.checkStringIsEmptyOrNull(caseObject.petitioner) ? "" : caseObject.petitioner.trim();
		return petitioner;
    }

    getCourtName = (caseObject) => {
        let courtName = "";
        courtName =  this.checkStringIsEmptyOrNull(caseObject.court_name) ? "" : caseObject.court_name.trim();
		return courtName;
    }

    getCaseYear = (caseObject) => {
        let caseYear = "";
        caseYear =  this.checkStringIsEmptyOrNull(caseObject.case_year) ? "" : caseObject.case_year.trim();
		return caseYear;
    }
    
    getRespondent = ( caseObject ) => {
		let respondent = "";
        respondent = this.checkStringIsEmptyOrNull(caseObject.respondent) ? "" : caseObject.respondent.trim()
		return respondent;
    }

    getAct = ( caseObject ) => {
        let acts = "";
        acts = this.checkStringIsEmptyOrNull(caseObject.acts) ? "" : caseObject.acts.trim()
        return acts;
    }

    handleDateChange = ( date ) => {
        this.setState({dateOfInc: date});
    }

    componentDidMount() {
        if (this.props.moderationType == "LEGAL"){
            if(this.props.legalUnprocessedData && this.props.legalUnprocessedData.legalCases.length > 0){
                let invalidCaseCount = 0;
                let incDate = null;
                if (this.props.legalUnprocessedData.dateOfIncorporation != null && this.props.legalUnprocessedData.dateOfIncorporation != "") {
                    incDate = moment(this.props.legalUnprocessedData.dateOfIncorporation, "DD-MM-YYYY", true);
                } else {
                    incDate = moment();
                }
                this.setState({ legalCases: this.props.legalUnprocessedData.legalCases, initialInvalidCaseCount : invalidCaseCount,  
                    invalidCaseCount : invalidCaseCount, dateOfInc : incDate.toDate()})
            }
        } else if (this.props.moderationType == "ADDITIONAL_LEGAL") {
            if (this.props.additionalLegalUnprocessedData && this.props.additionalLegalUnprocessedData.legalCases.length > 0){
                let invalidCaseCount = 0;
                let incDate = null;
                this.setState({ legalCases: this.props.additionalLegalUnprocessedData.legalCases, initialInvalidCaseCount : invalidCaseCount,  
                    invalidCaseCount : invalidCaseCount, dateOfInc : incDate})
            }
        }
    }

    componentDidUpdate(prevProps){
        if(this.props.legalProcessedData != prevProps.legalProcessedData ){
            this.props.Preloading(false);
            if(this.props.legalProcessedData.response == "Success"){
                toast.success(
                    <div>
                        <i className="fa fa-check"></i> {`Legal Moderation request placed Successfully !`}
                    </div>
                );
                this.props.getCrawlerStatus([{counterpartyId: this.props.legalUnprocessedData.counterpartyId, corporateId: this.props.corporateId}]);
                this.props.requestUnporcessedLegalDataForModeration(this.props.legalUnprocessedData.counterpartyId);
                this.props.moderateLegal();
                
            }else{
                toast.error(
                    <div>
                        <i className="fa fa-warning"></i>Something went wrong, Please try again !
                    </div>
                );
            }
            this.setState({resizeZIndex : false })
        }

        if(this.props.additionalLegalProcessedData != prevProps.additionalLegalProcessedData ){
            this.props.Preloading(false);
            if(this.props.additionalLegalProcessedData.response == "Success"){
                toast.success(
                    <div>
                        <i className="fa fa-check"></i> {`Additional Legal Moderation request placed Successfully !`}
                    </div>
                );
                this.props.getCrawlerStatus([{counterpartyId: this.props.additionalLegalUnprocessedData.counterpartyId, corporateId: this.props.corporateId}]);
                this.props.requestUnprocessedAdditionalLegalDataForModeration(this.props.additionalLegalUnprocessedData.counterpartyId);
                this.props.moderateAdditionalLegal();
                
            }else{
                toast.error(
                    <div>
                        <i className="fa fa-warning"></i>Something went wrong, Please try again !
                    </div>
                );
            }
            this.setState({resizeZIndex : false })
        }
        if (this.props.bulkDeleteResponse !== prevProps.bulkDeleteResponse) {
            this.props.Preloading(false);
            this.setState({ isExecutingTask: false, resizeZIndex: false });

            const resp = this.props.bulkDeleteResponse;

            if (resp && resp.status === "Success") {
                toast.success(
                    <div><i className="fa fa-check"></i> {resp.message || "Bulk deletion successful!"}</div>
                );
                this.props.getCrawlerStatus([{
                    counterpartyId: this.props.legalUnprocessedData.counterpartyId,
                    corporateId: this.props.corporateId
                }]);

                this.props.requestUnporcessedLegalDataForModeration(this.props.legalUnprocessedData.counterpartyId);

                this.props.moderateLegal();

                this.setState({ confirmModal: false, bulkDeleteFile: null, selectedFileName: "" });
            }
            else if (resp && resp.status === "Failure") {
                toast.error(
                    <div><i className="fa fa-warning"></i> {resp.message || "Something went wrong!"}</div>
                );
                this.setState({ confirmModal: false });
            }
        }
    }


    render() {
         const {  isExcelDownloading } = this.props;
        return (<React.Fragment>
            {isExcelDownloading && (
  <div className="legal-downloading">
    <div className="loader-container">
      <GridLoader size={20} color={'#00BFFF'} loading={true} />
      <span>Downloading Excel Template...</span>
    </div>
  </div>
)}
            <Modal show={this.props.open} className={ ( this.state.resizeZIndex  || this.state.confirmModal) ? "z-index-zero legal-modal Large-Modal" : " legal-modal Large-Modal" } >

                <ModalHeader className ="justify-content-center">
                    {this.props.moderationType == "LEGAL" ? <span>Legal Moderation -  {this.props.name}</span>
                    : <span>Additional Legal Moderation -  {this.props.name}</span> }
                </ModalHeader>
                <ModalBody>
                    {this.props.moderationType == "LEGAL" ? 

                    <React.Fragment>
                        <Row className="mb-2 ml-5">
                            <Col className="col-sm-9 mt-3">
                                <label>
                                        Delete all cases before Date of Incorporation
                                </label>
                            </Col>
                            <Col className="col-sm-8 mt-2">
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.dateOfInc ? moment(this.state.dateOfInc).toDate() : null}
                                    onChange={this.handleDateChange}
                                    placeholderText="Enter Date of Incorporation"
                                    dateFormat="dd-MM-yyyy"
                                    maxDate={moment()}
                                />
                            </Col>
                            <Col className="col-sm-4 mt-2"><Button color="primary" onClick={() => this.handleButtonDateOfInc(SUBMITDATE)} > Confirm </Button></Col>
                        </Row>    
                            <Row className="mb-4 ml-5">
                                <Col className="col-sm-12">
                                    <label className="font-weight-bold">Option 2: Bulk Delete via Excel</label>
                                </Col>

                                {/* Download Section */}
                                <Col className="col-sm-12 mt-2">
                                    <Button color="link" className="p-0" onClick={this.downloadBulkDeleteTemplate}>
                                        <i className="fa fa-download mr-1"></i> Download Excel Template for Bulk Delete
                                    </Button>
                                </Col>

                                {/* Upload Section */}
                                <Col className="col-sm-8 mt-3">
                                    <div className="custom-file">
                                        <input
                                            type="file"
                                            className="custom-file-input"
                                            id="bulkDeleteFile"
                                            accept=".xlsx"
                                            onChange={this.handleFileUploadChange}
                                        />
                                        <label className="custom-file-label" htmlFor="bulkDeleteFile">
                                            {this.state.selectedFileName || "Choose Excel File..."}
                                        </label>
                                    </div>
                                </Col>
                                <Col className="col-sm-4 mt-3">
                                    <Button
                                        color="success"
                                        disabled={!this.state.bulkDeleteFile}
                                        onClick={this.handleBulkDeleteConfirm} // This opens the confirmation modal
                                    >
                                        Upload & Delete
                                    </Button>
                                </Col>
                            </Row>
                        </React.Fragment>
                    : null}

                    <ViewLegalCases
                        tasks={Object.values(this.state.legalCases)}
                        handleOnChange={this.handleOnChange}/>
                </ModalBody>
                <ModalFooter>
                    <Row>
                    {/* <Col ><Button color="info" size="lg"  className="justify-content-center" onClick={(e) => this.handlePrevPageClick(e)} > Previous</Button></Col>
                    <Col><Button color="danger"  size="lg"  className="justify-content-center" onClick ={(e)=> this.handleNextPageClick(e)}> Next </Button></Col> */}

                        <Col ><Button color="info" size="lg"  className="justify-content-center" onClick={() => this.handleButton(CLOSE)} > Close </Button></Col>
                        <Col><Button color="danger"  size="lg"  className="justify-content-center" onClick ={()=> this.handleButton(SUBMIT)}>Delete Cases </Button></Col>
                    </Row>

                </ModalFooter>
            </Modal>
            <Modal show={this.state.confirmModal} className="legal-confirm-modal Large-Modal" >
                <ModalHeader>
                    {this.state.modalheader}
                </ModalHeader>
                <ModalBody>

                    {this.state.modalMessage}
                </ModalBody>
                <ModalFooter>
                    <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.handleConfirmModalButton (CANCEL, this.props.moderationType)} > Cancel </Button></Col>
                    <Col><Button color="danger" size="lg" className="justify-content-center" onClick={() => this.handleConfirmModalButton(PROCEED, this.props.moderationType)}> Proceed </Button></Col>
                </ModalFooter>
            </Modal>
            
        </React.Fragment>)
    }
}


const mapStateToProps = (state) =>({ 
    legalUnprocessedData : state.legalModeration.legalUnprocessedData,
    legalProcessedData : state.legalModeration.legalProcessedData,
    additionalLegalUnprocessedData: state.additionalLegalModeration.additionalLegalUnprocessedData,
    additionalLegalProcessedData: state.additionalLegalModeration.additionalLegalProcessedData,
    bulkDeleteResponse: state.legalModeration.uploadBulkDeleteExcelResponse,
    isExcelDownloading: state.legalModeration.isExcelDownloading || false,
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },

});

const mapDispatchToProps = dispatch => ({
    requestUnporcessedLegalDataForModeration : (data) => { dispatch(requestUnporcessedLegalDataForModeration(data)) },
    postProcessedDataToServer : (data) => { dispatch(postProcessedDataToServer(data))},
    requestUnprocessedAdditionalLegalDataForModeration : (data) => {dispatch(requestUnprocessedAdditionalLegalDataForModeration(data))},
    postProcessedAdditionalLegalDataToServer : (data) => {dispatch(postProcessedAdditionalLegalDataToServer(data))},
     downloadLegalBulkDeleteTemplate: (id, callback) => { 
        dispatch(downloadLegalBulkDeleteTemplate(id, callback)) 
    },
    uploadBulkDeleteExcel: (data) => { dispatch(uploadBulkDeleteExcel(data)) },
    Preloading : (data) => { dispatch(Preloading(data)) },
    getCrawlerStatus : (data) => { dispatch(getCrawlerStatus(data))}
});

export default connect(mapStateToProps, mapDispatchToProps)(LegalModeration);
